import React from 'react';
import { Telephone, Envelope } from 'react-bootstrap-icons';
import '../../views/AreasView.css';

const Area = ({ item }) => {
  return (
    <>
      {item != null && (
        <div className="area-box">
          <div className="area-nombre">{item.nombre}</div>
          <div className="area-sub">{item.domicilio}</div>
          <div className="area-sub">
            <Telephone /> Teléfono {item.telefono}
          </div>
          <div className="area-sub">
            <Envelope />{' '}
            <a className="area-link" href={'mailto:' + item.email}>
              {item.email}
            </a>
          </div>
        </div>
      )}
    </>
  );
};

export default React.memo(Area);
